<div class="admin-container">
    <div class="admin-content">
        <!-- Icon -->
        <div class="icon-container">
            <div class="admin-icon">⚙️</div>
        </div>

        <!-- Title -->
        <h1 class="title">Admin Workspace</h1>

        <!-- Description -->
        <p class="description">
            The <strong>{{ getWorkspaceDisplayName() }}</strong> workspace is currently under development.
        </p>

        <!-- Message -->
        <div class="message-box">
            <p class="message">
                We're actively building new features for this workspace. 
                Please check back soon for updates!
            </p>
        </div>

        <!-- Status Badge -->
        <div class="status-badge">
            <span class="badge-dot"></span>
            <span class="badge-text">Coming Soon</span>
        </div>

        <!-- Help Text -->
        <p class="help-text">
            If you have multiple workspace access, you can switch workspaces using the workspace switcher in the header.
        </p>
    </div>
</div>
